module.exports = __webpack_public_path__ + "r-v3/img/ico_close_gray.d3e8aed5.svg";